import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// A countdown is presentation only: reaching zero never ends a Live.
export const LiveScheduleCountdown = ({ scheduledAt, isOwner = false, testId, className = '' }) => {
  const { t } = useTranslation('lives');
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const tick = () => setNow(Date.now());
    tick();
    const timer = setInterval(tick, 1000);
    document.addEventListener('visibilitychange', tick);
    return () => { clearInterval(timer); document.removeEventListener('visibilitychange', tick); };
  }, [scheduledAt]);
  const seconds = Math.max(0, Math.ceil((new Date(scheduledAt).getTime() - now) / 1000));
  if (!Number.isFinite(seconds)) return null;
  const days = Math.floor(seconds / 86400);
  const pad = (n) => String(n).padStart(2, '0');
  const clock = `${pad(Math.floor(seconds / 3600) % 24)}:${pad(Math.floor(seconds / 60) % 60)}:${pad(seconds % 60)}`;
  return (
    <span data-testid={testId} className={`tabular-nums ${className}`} role="timer">
      {seconds > 0 ? t('schedule.starts_in', { time: `${days ? `${days}d ` : ''}${clock}` }) : t(isOwner ? 'schedule.ready' : 'schedule.awaiting_creator')}
    </span>
  );
};